



















import { Component, Prop, Vue } from 'vue-property-decorator';
import * as $ from 'jquery';
import DataTableNet from 'datatables.net';
import 'datatables.net-bs4';
import 'datatables.net-responsive';
import '../../public/uikitjs/DataTablesExtJS';
const namespace: string = 'counter';
import { Action, Getter } from 'vuex-class';
import BaseView from '../BaseView';
import Common from '../helper/Common';
import { systemTimezone } from '../constants/general';

@Component({})
export default class AudienceHistory extends BaseView {
    @Prop({ default: 0 })
    private AudienceId!: number;

    @Getter('currentClientId', { namespace })
    private clientId!: number;



    public InitAudienceHistoryTable(): void {
        // check if table already initialized
        if ($.fn.DataTable.isDataTable('#tableAudienceHistory')) {
            return;
        }
        const thisConponent = this;
        $('#tableAudienceHistory')
            .on('processing.dt', (e, settings, processing) => {
                // Hack to give some time for the table to render and take the
                // whole width of the container
                setTimeout(() => {
                    processing ?
                        Common.blockElement('tableAudienceHistory') :
                        Common.unblockElement('tableAudienceHistory');
                }, 50);
            })
            .DataTable({
                orderMulti: false, // restrict sort to only one column
                serverSide: true,
                searching: false, // disable filter
                columns: [
                    { name: 'audienceHistoryID', data: { _: 'audienceHistoryID' } },
                    { name: 'activityType', data: { _: 'activityType' } },
                    { name: 'activityByUser', data: { _: 'activityByUser' } },
                    { name: 'activityDate', data: { _: 'activityDate' } }
                ],
                ajax: {
                    url: `/api/DataTable/audience/api/v1.0/companyid/${thisConponent.clientId}/audience/${thisConponent.AudienceId}/history?api_user=${window.eInsightUserEmail}`,
                    type: 'POST',
                    error(xhr) {
                        console.log('Error Loading data', xhr);
                    }
                },
                lengthMenu: [ [10, 20, 50, 100, 500], [10, 20, 50, 100, 500] ],
                language: {
                    lengthMenu: ' _MENU_ entries ',
                    sSearch: 'Filter',
                    infoFiltered: '',
                },
                order: [[3, 'desc']],
                dom: '<<l><t>ip>',
                columnDefs: [
                    { targets: 'no-sort', orderable: false },
                    { targets: 'no-show', visible: false },
                    {
                        targets: 3, data: 'activityDate', render(data, type, row, meta) {
                            //const date = new Date(data).toLocaleDateString(window.eInsightUserRegion);
                            //const time = new Date(data).toLocaleTimeString(window.eInsightUserRegion);
                            //return date + ' ' + time;
                            const timezone = systemTimezone();
                            return Common.formatDateTime(data) + ` (${timezone})`;
                        }
                    },
                ],
                initComplete() {
                    $('select[name="tableAudienceHistory_length"]').removeClass('custom-select');
                }
            });
    }
}
